@if (authenticated) {
  <header
    #stepperHeader
    class="enrollment__header enrollment__header--desktop {{ displayType }}"
    [ngClass]="{ 'with--nav': withNav, 'with--toolbar': withToolbar }"
  >
    @if (showLeftScrollIcon) {
      <div
        (click)="handleScrollClicked(overflowDirections.left)"
        class="steps--control steps--control--left"
      >
        <i class="icon icon--medium" data-test-id="stepLeftScrollIcon"
          >chevron_left</i
        >
      </div>
    }
    <div class="container">
      <div
        (scroll)="checkForOverflow()"
        class="enrollment__header__steps"
        tabindex="0"
        role="region"
        aria-label="Stepper Section"
        #headerStepsContainer
      >
        @for (step of steps; track step; let i = $index) {
          <div
            [id]="step?.uniqueId"
            class="enrollment__header__step"
            [ngClass]="{
              'is-clickable': clickableSteps,
              'is-visited': i + 1 < activeStepIndex,
              'is-active': useStepType
                ? step.type === activeStepType
                : i + 1 === activeStepIndex,
            }"
          >
            @if (step.label) {
              @if (displayType === validStepperTypes.check) {
                <div class="status--indicator">
                  @if (i + 1 < activeStepIndex) {
                    <i class="icon icon--small" data-test-id="stepperCheckIcon">
                      check
                    </i>
                  } @else {
                    <p class="t-data" data-test-id="stepNotVisited">
                      {{ step.visibleStepIndex }}
                    </p>
                  }
                </div>
              }
              @if (displayType === validStepperTypes.iconDisplay && step.icon) {
                <i class="icon icon--medium" data-test-id="stepIcon">
                  {{ step.icon }}
                </i>
              }
              <p
                [ngClass]="{ 't-bold': i + 1 < activeStepIndex }"
                class="t-data t-alt Stepper__Label"
                (click)="
                  i + 1 < activeStepIndex
                    ? stepIsClicked(
                        { displayIndex: step.stepIndex, step: step },
                        clickableSteps
                      )
                    : null
                "
                data-test-id="stepLabel"
              >
                {{ getStepLabel(step) }}
              </p>
              @if (
                i + 1 !== steps.length &&
                (displayType === validStepperTypes.check ||
                  displayType === validStepperTypes.iconDisplay)
              ) {
                <div class="divider"></div>
              }
              @if (
                i + 1 !== steps.length &&
                displayType === validStepperTypes.default
              ) {
                <i class="icon icon--medium" data-test-id="stepArrowRight">
                  carat_right
                </i>
              }
            }
          </div>
        }
      </div>
      @if (showRightScrollIcon) {
        <div
          (click)="handleScrollClicked(overflowDirections.right)"
          class="steps--control steps--control--right"
        >
          <i class="icon icon--medium" data-test-id="stepRightScrollIcon"
            >chevron_right</i
          >
        </div>
      }
    </div>
  </header>
}

<header
  class="enrollment__header enrollment__header--tablet-mobile"
  [ngClass]="{ 'with--toolbar': withToolbar }"
>
  <div class="container">
    @if (steps) {
      <div [ngClass]="{ open: showMobileStepper }" class="stepper--label">
        <div class="u-flex">
          <i
            (click)="toggleShowMobileStepper()"
            class="icon icon--medium icon--pointer"
            [ngClass]="{ 'icon--rotate180': showMobileStepper }"
            data-test-id="mobileStepperToggle"
          >
            chevron_down
          </i>
          <p class="t-data t-bold" data-test-id="mobileStepperHeader">
            Step {{ activeStepIndex }} of {{ steps.length }}:
            {{ getStepLabel(steps[activeStepIndex - 1]) }}
          </p>
        </div>
        @if (steps[activeStepIndex]) {
          <p class="t-data t-alt" data-test-id="mobileNextStep">
            Next: {{ getStepLabel(steps[activeStepIndex]) }}
          </p>
        }
      </div>
    }
    @if (showMobileStepper) {
      <div class="other--steps" @accordion>
        @for (step of steps; track step; let i = $index) {
          <div
            [ngClass]="{
              'is-visited': i + 1 < activeStepIndex,
              'is-active': i + 1 === activeStepIndex,
            }"
            class="step--display"
          >
            <div class="indicator"></div>
            <p class="t-data" data-test-id="mobileStepLabel">
              {{ getStepLabel(step) }}
            </p>
          </div>
        }
      </div>
    }
  </div>
</header>
